"use client";

import { CURRENCY_CODE } from "@/lib/constant";
import Script from "next/script";
import { useEffect } from "react";
const TabbyPromoSnippet = ({
  price,
  currency = CURRENCY_CODE,
  lang = "en",
  source = "product"
}) => {
  const removeComma = price?.replace(/,/g, "");
  const numericPrice = parseFloat(removeComma);
  useEffect(() => {
    const initTabbyWidget = () => {
      if (typeof window !== "undefined") {
        new TabbyPromo({
          selector: "#TabbyPromo",
          // required, id of the div
          currency,
          // currency of the product (e.g., 'SAR')
          price: numericPrice,
          lang,
          // 'en' or 'ar' for language
          source,
          // 'product' or 'cart'
          publicKey: process.env.NEXT_PUBLIC_TABBY_PUBLIC_KEY // required public key
        });
      } else {
        console.error("TabbyPromo is not defined");
      }
    };
    const timer = setTimeout(initTabbyWidget, 1000); // Wait for 2 seconds

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [currency, price, lang, source, numericPrice]);
  return <>
      {/* Div where Tabby promo will be rendered */}
      <div id="TabbyPromo"></div>
      {/* Tabby Promo Script */}
      <Script src="https://checkout.tabby.ai/tabby-promo.js" strategy="afterInteractive" onError={e => {
      console.error("Tabby script failed to load", e);
    }} data-sentry-element="Script" data-sentry-source-file="TabbyPromoSnippet.jsx" />
    </>;
};
export default TabbyPromoSnippet;